/** Undo swipe-dismiss chrome when a sheet close was vetoed (e.g. confirm dialog cancel). */
export function restoreNativeSheetAfterDismissVeto(): void {
  if (typeof document === "undefined") return;

  document
    .querySelectorAll<HTMLElement>(
      '[role="dialog"][data-state="open"].native-bottom-sheet, [role="alertdialog"][data-state="open"].native-bottom-sheet',
    )
    .forEach((sheet) => {
      sheet.getAnimations().forEach((a) => a.cancel());
      sheet.classList.remove(
        "native-sheet-dismissing",
        "native-sheet-exit-locked",
        "native-sheet-dragging",
      );
      sheet.style.transform = "";
      sheet.style.opacity = "";
      sheet.style.pointerEvents = "";
    });

  document
    .querySelectorAll<HTMLElement>(
      "[data-radix-dialog-overlay], [data-radix-alert-dialog-overlay]",
    )
    .forEach((overlay) => {
      const openDialog = document.querySelector(
        '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]',
      );
      if (!openDialog) return;
      overlay.getAnimations().forEach((a) => a.cancel());
      overlay.classList.remove("native-sheet-overlay-dismissing");
      overlay.style.opacity = "";
      overlay.style.pointerEvents = "";
    });
}
